import React from 'react';
import { Helmet } from 'react-helmet';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>NOVIONIX Labs – Intelligence in Motion</title>
        <meta
          name="description"
          content="Adaptive intelligence that evolves through real-time feedback loops."
        />
        <meta
          name="keywords"
          content="NOVIONIX, adaptive AI, real-time cognition, HIE framework"
        />
        <meta property="og:title" content="NOVIONIX Labs – Intelligence in Motion" />
        <meta
          property="og:description"
          content="Adaptive intelligence that evolves through real-time feedback loops."
        />
        <meta property="og:image" content="https://novonix-labs-development.web.app/logo.jpg" />
        <meta property="og:url" content="https://novonix-labs-development.web.app/" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <main className="home">
        <video
          className="bg-video"
          autoPlay
          muted
          loop
          playsInline
          poster="/node-poster.jpg"
          aria-label="Background motion graphic"
        >
          <source src="/node.mp4" type="video/mp4" />
          <p>Your browser doesn’t support video—enjoy our static background instead.</p>
        </video>

        <div className="overlay">
          <h1>NOVIONIX Labs</h1>
          <p className="tagline">Beyond AI — Intelligence in Motion</p>
          <p className="subtext">
            Intelligence that learns and adapts in the flow of real-world dynamics.
          </p>
          <p className="subtext">
            From optimizing live sports tactics to driving dynamic healthcare responses, our proprietary HIE engine puts intelligence where it moves.
          </p>
        </div>
      </main>
    </>
  );
}
